<template>
  <div id="content" class="manage_default_data">
    <div class="p-rl-20" v-if="internalAssessment.status == 'completed' && !seeMyAssessment">
      <div class="internalAssessment_inner tcenter">
        <div class="thank_you_container">
          <div class="thank_you">
            <div class="titre_1">
              Thank you for your engagement.
            </div>
            <div class="image_1">
              <img :src="require('@/assets/thanyouimage.png')" alt="">
            </div>
            <div class="text_1 texte_1">
              <p>Unfortunately, the deadline for this assessment has now passed. </p>
              <p>We look forward to collaborating with you on future innovator assessments. </p>

            </div>
          </div>
          <div class=" tcenter">
            <button @click="seeMyAssessment = true" type="button" class="next_step_btn" style="display:inline-block;padding:10px 20px;font-size:20px;background:#115AA4;color:#FFF;border-radius:50px;"  name="button">{{$t("See my assessments")}}</button>

          </div>
        </div>

      </div>

    </div>



      <JudgeViewSummary :internalAssessment="internalAssessment" :token="token" :votes="votes" :showBackBtn='true' v-if="seeMyAssessment"/>

        <!-- <div class="content_div stats" v-if="internalAssessment">
          <JudgeViewSummary :internalAssessment="internalAssessment" :token="token" :votes="votes"/>

        </div> -->


  </div>
</template>

<script>
// import { QuillEditor } from '@vueup/vue-quill'
// import '@vueup/vue-quill/dist/vue-quill.snow.css';
 import JudgeViewSummary from '@/components/JudgeViewSummary.vue'

//
// //import { Toaster, toast } from 'vue-sonner'
// import CreateCriteriaModal from '@/components/modals/createCriteria.vue'
// import CriteriaDetails from '@/components/CriteriaDetail.vue'
 // import api from '../tools/api';
 import { toast } from 'vue-sonner'
export default {
  components: {
    JudgeViewSummary
    // QuillEditor,
    // CreateCriteriaModal,
  //   CriteriaDetails,
  //  StartupInfoLine
  },
  name: 'InternalAssessmentPreview',
  data() {
    return {
      dialog:false,
      pageInfo: {
        mainTitle : "My assessment space ",
        subTitle : this.$t("Preview"),
      },
      votes:[],
      seeMyAssessment:true,
      nameForInit : "",
      demoValue:[],
      demoDisable:[],
      showSidePanelBasic: false,
      showDetailsIndexInSelected:null,
      showDetailsIndexInFav:null,
      step: 0,
      token:"",
      internalAssessment : {
        type:"",
        user:null,
        name : "",
        project : null,
        deadline : null,
        description : "",
        criterias : [],
        disableFeedback : false,
        feedback_1 : "",
        feedback_2 : "",
        feedback_3 : "",
        comments:"",
        startups : [],
        judges : []
      },

    }
  },
  methods:{
    getGroupNameById(id) {
      console.log("search id:",id);
      console.log(this.criteriaGroups);
      var group = this.criteriaGroups.find(g => g._id.$oid == id.$oid);
      console.log("dinf ",group);
      return group ? group.name : null; // Return the groupname or null if not found
    },
    getNotAssessedStartups(){
      var votedStartupIds = this.votes.length ? new Set(this.votes.map(vote => vote.startup._id.$oid)) : new Set(); // Handle empty votes array
      console.log(this.votes);
      console.log(votedStartupIds);
      var iii =  this.internalAssessment.startups.filter(startup =>
      !votedStartupIds.has(startup._id.$oid)
    );

    return iii;
  },
    toggleDetailsSelected(index) {

      if (this.showDetailsIndexInSelected === index) {
        this.showDetailsIndexInSelected = null; // Hide if already visible
      } else {
        this.showDetailsIndexInSelected = index; // Show the clicked index
        this.showDetailsIndexInFav = null; // Hide if already visible
        this.showDetailsIndexInAvailable = null; // Hide if already visible
        this.showDetailsGroupIndexInAvailable = null;
      }
    },
    hideDetails(){
      this.showDetailsIndexInFav = null; // Hide if already visible
      this.showDetailsIndexInSelected = null;
      this.showDetailsIndexInAvailable = null; // Hide if already visible

    },
    getAssessmentForJudge(step){
      this.token = this.$route.params.token;
      this.axios.get(process.env.VUE_APP_API_URL+"/judgeAssessment/"+this.$route.params.token+"/"+this.$route.params.id).then( (r) => {
        this.internalAssessment = r.data;
        // if(this.internalAssessment.status == 'completed')this.seeMyAssessment = false;
        // else this.seeMyAssessment = true;
        if(this.internalAssessment.deadline){
          this.deadlineDateFormated = this.internalAssessment.deadline.date.split(' ')[0];
        }
        this.nameForInit = this.internalAssessment.judges.name;
        this.internalAssessment.criterias.forEach((item,i) => {
          console.log(item);
          this.demoValue[i] = 3;
          this.demoDisable[i] = false;
        });
        this.step = step;

      }).catch( (e) => console.log(e));
    },
    getAssessmentVoteForJudge(){
      this.token = this.$route.params.token;
      this.axios.get(process.env.VUE_APP_API_URL+"/judgeVotes/"+this.$route.params.token+"/"+this.$route.params.id).then( (r) => {
        this.votes = r.data;
        if(this.internalAssessment.status == 'completed')this.seeMyAssessment = false;
        else{
          this.seeMyAssessment = true;
        }

            }).catch( (e) => {console.log(e);this.seeMyAssessment = true;});
    },
    confirmJudgeName(){
      this.axios.post(process.env.VUE_APP_API_URL+"/setJudgeName",
        {
          assessment :this.internalAssessment,
          token : this.$route.params.token,
        },
        { headers: {'Content-Type': 'application/json',}}
      ).then( (r) => {
          console.log("dfqsd",r.data);
          this.getAssessmentForJudge(1);
        }).catch( (e) => {
          console.log(e);
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
    },
    transformDate(dateString) {
 const date = new Date(dateString);
 const day = String(date.getDate()).padStart(2, '0');
 const month = String(date.getMonth() + 1).padStart(2, '0');
 const year = date.getFullYear();
 return `${day}/${month}/${year}`;
},
},
  mounted(){
    console.log(this.$route.params);
    if(this.$route.params.id != "undefined" && this.$route.params.token != "undefined"){
      this.getAssessmentForJudge(1);
      this.getAssessmentVoteForJudge();

     }

     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)

     // api.get(process.env.VUE_APP_API_URL+"/restrict/mycriteriabygroup").then( (r) => {
     //   this.criteriaGroups = r.data;
     //   console.log("criterias : ",r.data);
     //   console.log(r);
     // }).catch( (e) => console.log(e));

  },
  computed:{

},
watch:{

}

}
</script>
<style media="screen" scoped>
.manage_default_data{
  padding-top:50px;
  padding-bottom: 50px;
  padding: 50px;
}
.content_div{
  /* margin-top:50px;
  margin-bottom: 50px; */
  padding: 50px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
}


.tcenter{
  text-align:center;
}
.thank_you_container{
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 100px;
  padding-bottom: 100px;
  background: #FFF;
  flex-direction: column;
  gap:30px;
}
.thank_you{
  background:#F0F5FA;
  padding:50px;
  padding-bottom:0px;
  border-radius:50px;
  max-width:635px;
}
.thank_you .titre_1{
  color:#3783C5;
  font-weight:600;
  font-size:27px;
}
.thank_you .text_1{
  margin-top:30px;
  margin-bottom:20px;
  color:#04246A;
  font-size:15px;
}

.p-rl-20{
    padding-right:20px;
    padding-left:20px;

}



</style>
